import React from "react";
import { Toast, Button, ButtonToolbar } from "react-bootstrap";
import { FaIcon } from "lib/FaIcon";
import { _t } from "app/i18n/i18n";
import { Link } from "react-router-dom";
import { addPubToReadingList, hideNotification } from "../api/readingListApi";
import { useEffect } from "react";
const NOTIFICATION_TIMEOUT = 5000;

export const ReadingListNotification = ({ mode = "add", publication, id }) => {
  useEffect(() => {
    setTimeout(onClose, NOTIFICATION_TIMEOUT);
  });
  const onClose = () => hideNotification(id);

  return !publication ? null : (
    <Toast onClose={onClose} show={true} className="d-flex mb-2 flex-basis-auto">
      {mode === "add" && <ToastIcon icon="fas fa-check" bg="bg-primary" />}
      {mode === "remove" && <ToastIcon icon="fas fa-eraser" bg="bg-primary" />}
      {(mode === "add-error" || mode === "remove-error") && <ToastIcon icon="fas fa-exclamation" bg="bg-warning" />}
      {mode === "duplicate" && <ToastIcon icon="fas fa-clipboard-check " bg="bg-primary" />}
      {mode === "reading-list-full" && <ToastIcon icon="fab fa-stack-overflow " bg="bg-primary" />}

      <article className="w-100">
        <Toast.Header className="text-dark font-weight-bold">
          {mode === "add" && _t("Added to Reading List")}
          {mode === "remove" && _t("Removed from Reading List")}
          {mode === "duplicate" && _t("Already in Reading List")}
          {mode === "reading-list-full" && _t("Your Reading List is full")}
          {mode === "add-error" && _t("Error adding to Reading List")}
          {mode === "remove-error" && _t("Error removing from your Reading List")}
          <span className="mr-auto" />
        </Toast.Header>

        <Toast.Body>
          {(mode === "add" || mode === "remove" || mode === "duplicate") && <em>{publication.title}</em>}
          {(mode === "add-error" || mode === "remove-error") &&
            _t("Sorry, there was an error serving this request, please try again later")}
          {mode === "reading-list-full" && _t("Please remove some publications from your reading list")}

          <ButtonToolbar className="justify-content-between flex-row-reverse mt-3">
            <DismissButton onClose={onClose} />
            {(mode === "add" || mode === "duplicate" || mode === "reading-list-full") && (
              <ViewReadingListButton onClose={onClose} />
            )}
            {mode === "remove" && <UndoButton onClose={onClose} publication={publication} />}
          </ButtonToolbar>
        </Toast.Body>
      </article>
    </Toast>
  );
};

const ToastIcon = ({ bg, icon }) => (
  <aside className={"d-flex flex-column " + bg}>
    <FaIcon icon={icon + " text-white fa-3x m-auto"} />
  </aside>
);

const DismissButton = ({ onClose }) => (
  <Button onClick={onClose} variant="outline-secondary btn-sm ml-2">
    {_t("Dismiss")}
  </Button>
);

const ViewReadingListButton = ({ onClose }) => (
  <Link to="/My_Reading_List">
    <Button onClick={onClose} variant="outline-secondary btn-sm">
      {_t("View your Reading List")}
    </Button>
  </Link>
);

const UndoButton = ({ onClose, publication }) => (
  <Button
    onClick={() => {
      addPubToReadingList(publication);
      onClose();
    }}
    variant="outline-secondary btn-sm"
  >
    {_t("Undo")}
  </Button>
);
